import { handleGetData } from '../../Api';
import { semAcento } from '../PhotoGallery/dados';

export { aplicarMetadados, contagem, semAcento } from '../PhotoGallery/dados';

// A página lê duas coisas: os textos (`pagina-unidades`) e todas as unidades
// publicadas (são poucas dezenas: vêm de uma vez, e a busca, os filtros e a
// contagem rodam no navegador).
let emAndamento = null;

const paraUnidade = (item) => {
  const d = item.data || {};
  const local = d.localizacao?.iv;
  return {
    id: item.id,
    nome: d.nome?.iv || '',
    tipo: d.tipo?.iv || '',
    cidade: d.cidade?.iv || '',
    estado: d.estado?.iv || 'MS',
    endereco: d.endereco?.iv || '',
    telefone: d.telefone?.iv || '',
    email: d.email?.iv || '',
    foto: d.foto?.iv?.[0] || null,
    // Squidex guarda o ponto como { latitude, longitude }; sem ponto, o mapa
    // procura pelo endereço.
    ponto: local?.latitude != null && local?.longitude != null ? `${local.latitude},${local.longitude}` : null,
  };
};

// A Sede primeiro, depois as unidades da cidade dela e então as outras cidades,
// em ordem alfabética (e o nome dentro de cada cidade).
const ordenar = (lista) => {
  const sede = lista.find((u) => u.tipo === 'Sede');
  const peso = (u) => (u === sede ? 0 : u.cidade === sede?.cidade ? 1 : 2);
  return [...lista].sort(
    (a, b) => peso(a) - peso(b) || a.cidade.localeCompare(b.cidade, 'pt-BR') || a.nome.localeCompare(b.nome, 'pt-BR'),
  );
};

export const carregarUnidades = (token) => {
  if (!emAndamento) {
    emAndamento = Promise.all([
      handleGetData(token, 'api/content/copasul/pagina-unidades/').then((r) => r?.data?.items?.[0]?.data || {}),
      handleGetData(token, 'api/content/copasul/unidade/?$top=200').then((r) => r?.data?.items || []),
    ])
      .then(([pagina, itens]) => {
        const campo = (nome) => pagina[nome]?.iv || {};
        return {
          topo: campo('topo'),
          faixaFinal: pagina.faixaFinal?.iv || null,
          metadados: campo('metadados'),
          lista: ordenar(itens.map(paraUnidade).filter((u) => u.nome)),
        };
      })
      .catch((e) => {
        emAndamento = null;
        throw e;
      });
  }
  return emAndamento;
};

// Opções dos filtros: só o que existe nas unidades, sem repetir, em ordem alfabética.
export const opcoes = (lista, campo) =>
  [...new Set(lista.map((u) => u[campo]).filter(Boolean))].sort((a, b) => a.localeCompare(b, 'pt-BR'));

export const filtrar = (lista, { busca, cidade, tipo }) => {
  const termo = semAcento(busca.trim());
  return lista.filter(
    (u) =>
      (!cidade || u.cidade === cidade) &&
      (!tipo || u.tipo === tipo) &&
      (!termo || semAcento(`${u.nome} ${u.cidade}`).includes(termo)),
  );
};

// O lugar no Google Maps: o ponto marcado no Squidex ou, sem ele, a unidade
// pelo nome. Testado (30/10): "Copasul <nome>, <cidade>" acha o cadastro da
// unidade no Google e põe o pino nela; pelo endereço ("Rodovia BR 487, km 86")
// o mapa só mostra a estrada, sem pino. Unidade sem cadastro no Google só
// aparece com o ponto marcado.
const lugar = (u) => u.ponto || `Copasul ${u.nome}, ${u.cidade} - ${u.estado}`;
export const mapaDe = (u) => `https://maps.google.com/maps?q=${encodeURIComponent(lugar(u))}&z=15&output=embed`;
export const rotaPara = (u) => `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(lugar(u))}`;

export const telefoneLink = (telefone) => `tel:+55${telefone.replace(/\D/g, '')}`;

// Rótulos de interface: sempre os mesmos, ficam aqui e não no Squidex.
export const ROTULOS = {
  busca: 'Qual unidade você procura?',
  buscaPlaceholder: 'Busque pelo nome da unidade…',
  cidade: 'Cidade',
  todasCidades: 'Todas as cidades',
  tipo: 'Tipo de unidade',
  todosTipos: 'Todos os tipos',
  unidade: ['unidade encontrada', 'unidades encontradas'],
  limpar: 'Limpar filtros',
  dica: 'Clique em uma unidade para ver a localização',
  verLocalizacao: 'Ver localização',
  carregarMais: 'Carregar mais',
  fim: 'Você chegou ao fim da seleção',
  vazioTitulo: 'Nenhuma unidade encontrada',
  vazioTexto: 'Tente outro nome ou limpe os filtros.',
  informacoes: 'Informações da unidade',
  endereco: 'Endereço',
  telefone: 'Telefone',
  email: 'E-mail',
  legendaMapa: 'Use os controles do mapa para explorar',
  tracarRota: 'Traçar rota',
  fechar: 'Fechar',
  mapa: 'Mapa da unidade',
};
